export default __webpack_public_path__ + "static/media/Acudipin-Plus-eng.6d8e6a55.jpg";